<template>
  <div class="AlertNotification">
    <div class="flex">
      <div>
        <aw-icon
          v-if="isSuccess"
          icon="check"
          class="w-6 h-6 text-white "
        />
        <aw-icon
          v-if="isError"
          icon="error"
          class="w-6 h-6 text-white "
        />
        <aw-icon
          v-if="isInfo"
          icon="info"
          class="w-6 h-6 text-white "
        />
      </div>
      <div class="px-4 flex-grow min-w-0 break-words">
        <div class="text-base text-white font-semibold min-w-0">
          {{ heading }}
        </div>
        <div class="text-sm text-white min-w-0" v-if="message">
          {{ message }}
        </div>
      </div>
      <div class="flex-shrink-0">
        <aw-icon
          @click="close()"
          icon="close"
          class="w-5 h-5 text-white cursor-pointer"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from 'vue-toastification'
import AwIcon from 'nette-base-module/js/components/AwIcon.vue'

export default {
  props: ['alert', 'heading', 'message', 'toastId'],
  components: {
    AwIcon
  },
  computed: {
    isError() {
      return this.alert === 'error'
    },
    isSuccess() {
      return this.alert === 'success'
    },
    isInfo() {
      return this.alert === 'info'
    }
  },
  methods: {
    close() {
      const toast = useToast()
      toast.dismiss(this.toastId)
    }
  }
}
</script>

<style lang="scss" scoped></style>
